import { render, staticRenderFns } from "./szx.vue?vue&type=template&id=1f775595"
import script from "./szx.vue?vue&type=script&lang=js"
export * from "./szx.vue?vue&type=script&lang=js"
import style0 from "./szx.vue?vue&type=style&index=0&id=1f775595&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports